<template>
    <div
        v-if="canReadPrices && (hasVolumeDeal || volumeLoading)"
        class="bo-ta-pricing-deals"
        :aria-busy="volumeLoading"
    >
        <div
            v-if="hasVolumeDeal"
            class="ta-deal"
            :class="{ refreshing: volumeLoading }"
        >
            <button
                type="button"
                class="ta-deal-toggle"
                :class="{ expanded: volumeExpanded }"
                @click="volumeExpanded = !volumeExpanded"
            >
                <i class="icon-chevronright"></i>
                <span>{{ volumeTitle }}</span>
            </button>
            <div
                v-if="volumeExpanded"
                class="ta-deal-body"
            >
                <div class="ta-deal-tabs">
                    <span class="ta-deal-tab active theme-primary-color">{{ productTranslations.quantity }}</span>
                </div>
                <table class="ta-deal-table">
                    <thead>
                        <tr>
                            <th>{{ productTranslations.quantity }}</th>
                            <th>{{ unitPriceHeader }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="tier in volumeTiers"
                            :key="tier.min_quantity"
                        >
                            <td>{{ formatRange(tier) }}</td>
                            <td>{{ formatAmount(displayPrice(tier.unit_price)) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div
            v-else-if="volumeLoading"
            class="ta-deal ta-deal-skeleton"
            aria-hidden="true"
        >
            <span class="ta-deal-skeleton-ghost"></span>
        </div>
    </div>
</template>

<script>
import { priceVisibilityMixin } from "js/frontend/mixins/price-visibility.js";

export default {
    mixins: [priceVisibilityMixin],
    props: {
        // [{min_quantity, max_quantity, unit_price, ...}]
        volumeTiers: {
            type: Array,
            default: () => [],
        },
        // stored price -> displayed price (tax in or out), as the page shows its other prices
        displayPrice: {
            type: Function,
            default: (price) => price,
        },
        // a request is in flight: a placeholder row on first load, the current rows dimmed on refresh
        volumeLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            productTranslations: window.bo?.productTranslations ?? {},
            currencySymbol: window.bo?.currencySymbol ?? "RM",
            volumeExpanded: false,
        };
    },
    computed: {
        // one range means the price never changes with quantity
        hasVolumeDeal() {
            return this.volumeTiers.length > 1;
        },
        volumeTitle() {
            const lowest = Math.min(...this.volumeTiers.map((tier) => Number(tier.unit_price)));
            return this.productTranslations.buy_more_pay_as_low_as.replace(
                ":price",
                this.formatAmount(this.displayPrice(lowest))
            );
        },
        unitPriceHeader() {
            return this.productTranslations.unit_price.replace(":currency", this.currencySymbol);
        },
    },
    methods: {
        formatAmount(amount) {
            const value = Number(amount).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            return `${this.currencySymbol} ${value}`;
        },
        formatQuantity(quantity) {
            return Number(Number(quantity).toFixed(4)).toString();
        },
        formatRange(tier) {
            if (tier.max_quantity === null) {
                return `≥ ${this.formatQuantity(tier.min_quantity)}`;
            }
            if (tier.max_quantity == tier.min_quantity) {
                return this.formatQuantity(tier.min_quantity);
            }
            return `${this.formatQuantity(tier.min_quantity)} - ${this.formatQuantity(tier.max_quantity)}`;
        },
    },
};
</script>
